import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { Products } from "../components/landing/Products";
import { Steps } from "../components/landing/Steps";
import { Proof } from "../components/landing/Proof";
import { Faq } from "../components/landing/Faq";
import { Footer } from "../components/landing/Footer";
import { PaymentStatus } from "../components/landing/PaymentStatus";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#050608] text-white" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Products />
      <Steps />
      <Proof />
      <Faq />
      <Footer />
      <PaymentStatus />
    </div>
  );
}
